import React, { useState } from "react";
import {
  CardInnerDiv,
  CardWrapper,
  ContentDiv,
  MainDiv,
  MainSection,
  MainWrapper,
  RightDiv,
  TabsWrapper,
  TopTitle,
} from "./stakingpopupElements";
import {
  c98cardimg2,
  crossicon,
  innerimg,
  maincardimg,
  mobilecardimg,
} from "assets";
import { Image } from "react-bootstrap";
import TabsContent from "./tabsContent";
import { Link, useLocation } from "react-router-dom";
import { useWalletConnectClient } from "services/walletServices";
import { CommonUtility } from "utility/common";
import { stakingAbi } from "utility/contract/nftStakingAbi";
import environment from "environment";
import { ToastMessage } from "components/common";
import { elgNftAbi } from "utility/contract/elgNftAbi";
import Loading from "components/common/loaders/loading";
import { CloseDiv } from "./elements";

const StakingPopupComp = ({ getUserNfts, getClaimedReward, getUserStaked }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  // Get the value of the "paramName" query parameter
  const id = searchParams.get("id");
  function makeFourDigitNumber(num) {
    let numStr = num.toString(); // Convert number to string
    while (numStr.length < 4) {
      numStr = "0" + numStr; // Prepend zeros until it becomes 4 digits long
    }
    return numStr;
  }
  console.log("XYZYZYZ", id);
  const data = [
    {
      name: "NFT ID",
      value: `#${makeFourDigitNumber(id)}`,
    },
    {
      name: "Name",
      value: "Element Legend",
    },
    {
      name: "Trait",
      value: "Golden",
    },
    {
      name: "Equippable",
      value: "Shoes",
    },
  ];

  const { web3Provider, account } = useWalletConnectClient();
  const [isLoading, setIsLoading] = useState(false);
  const [activeDiv, setActiveDiv] = useState(3);
  const [confirmtext, setConfirmText] = useState(false);

  // const handleDivClick = (divNumber) => {
  //   setActiveDiv(divNumber);
  // };

  const handleDivClick = (div) => {
    if (div === 3) {
      setActiveDiv(div);
    }
  };

  const stakeNft = async () => {
    try {
      setIsLoading(true);
      console.log("HANDLE STAKE");
      const contract = CommonUtility.contract(
        web3Provider,
        stakingAbi,
        environment.STAKING_CONTRACT[environment.DEFAULT_CHAIN]
      );
      const info = await contract.methods.getUserAllStakings(account).call();
      if (info.length == 5) throw "Can stake upto 5 nfts";

      const nftContract = CommonUtility.contract(
        web3Provider,
        elgNftAbi,
        environment.ELG_NFT[environment.DEFAULT_CHAIN]
      );
      const approveEstimatedGasLimit = await nftContract.methods
        .approve(environment.STAKING_CONTRACT[environment.DEFAULT_CHAIN], id)
        .estimateGas({ from: account });
      const approveGasPrice = await web3Provider.eth.getGasPrice();
      const approval = await nftContract.methods
        .approve(environment.STAKING_CONTRACT[environment.DEFAULT_CHAIN], id)
        .send({
          from: account,
          gasLimit: web3Provider.utils.toHex(
            +approveEstimatedGasLimit + environment.GAS_LIMIT_BUFFER
          ),
          gasPrice: web3Provider.utils.toHex(
            +approveGasPrice + environment.GAS_PRICE_BUFFER
          ),
        });

      if (approval && approval.code == 4001)
        throw "User denied the transaction";
      if (!approval.status) throw "Transaction Failed";
      const estimatedGasLimit = await contract.methods
        .stake(id, +activeDiv - 1)
        .estimateGas({ from: account });
      const currentGasPrice = await web3Provider.eth.getGasPrice();
      const txn = await contract.methods.stake(id, +activeDiv - 1).send({
        from: account,
        gasLimit: web3Provider.utils.toHex(
          +estimatedGasLimit + environment.GAS_LIMIT_BUFFER
        ),
        gasPrice: web3Provider.utils.toHex(
          +currentGasPrice + environment.GAS_PRICE_BUFFER
        ),
      });
      if (txn && txn.code == 4001) throw "User denied the transaction";
      if (!txn.status) throw "Transaction Failed";
      await getUserNfts();
      await getUserStaked();
      await getClaimedReward();
      setConfirmText(true);
      if (txn.status) {
        setIsLoading(false);
        ToastMessage("Success!", "Transaction successful", "success");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      if (error?.message) {
        ToastMessage("Error", error?.message, "error");
      } else {
        ToastMessage("Error", error, "error");
      }
    }
  };
  return (
    <>
      <CloseDiv>
        <Link to="/">
          <Image src={crossicon} />
        </Link>
      </CloseDiv>
      <MainSection>
        {isLoading && <Loading content={"Transaction in progress"} />}

        <MainDiv>
          <Image src={maincardimg} className="maininnerimg" />
          <Image src={mobilecardimg} className="maininnerimg2" />
          <MainWrapper>
            <CardWrapper>
              <Image src={c98cardimg2} className="innerimg" />

              <CardInnerDiv>
                <div className="mask1">
                  <Image
                    src={`https://gateway.pinata.cloud/ipfs/QmY59S3UQCeeFBLJoUDteASfr2m73fmFxdWr6HqQA18999/${id}.png`}
                    fluid
                  />
                </div>
                <h1>Elemental Legend</h1>

                {data.map((item) => (
                  <>
                    <div className="content-div">
                      <h5>{item.name}</h5>
                      <p>{item.value}</p>
                    </div>
                  </>
                ))}
              </CardInnerDiv>
            </CardWrapper>

            <RightDiv>
              <TopTitle>STAKE ・ PLAY ・ EARN</TopTitle>
              <div className="main-tab-div">
                <TabsWrapper>
                  <div
                    onClick={() => handleDivClick(1)}
                    className={`${
                      activeDiv === 1 ? "tab-active" : "non-active"
                    }`}
                  >
                    <h5>07 days</h5>
                  </div>
                  <div
                    onClick={() => handleDivClick(2)}
                    className={`${
                      activeDiv === 2 ? "tab-active" : "non-active"
                    }`}
                  >
                    <h5>15 days</h5>
                  </div>
                  <div
                    onClick={() => handleDivClick(3)}
                    className={`${
                      activeDiv === 3 ? "tab-active" : "non-active"
                    }`}
                  >
                    <h5>30 days</h5>
                  </div>
                  <div
                    onClick={() => handleDivClick(4)}
                    className={`${
                      activeDiv === 4 ? "tab-active" : "non-active"
                    }`}
                  >
                    <h5>60 days</h5>
                  </div>
                </TabsWrapper>
              </div>
              {/* <ContentDiv>
                {activeDiv === 1 ? (
                  <>
                    <TabsContent
                      days="07"
                      stakeNft={stakeNft}
                      confirmtext={confirmtext}
                    />
                  </>
                ) : activeDiv === 2 ? (
                  <TabsContent
                    days={15}
                    stakeNft={stakeNft}
                    confirmtext={confirmtext}
                  />
                ) : activeDiv === 3 ? (
                  <TabsContent
                    days={30}
                    stakeNft={stakeNft}
                    confirmtext={confirmtext}
                  />
                ) : activeDiv === 4 ? (
                  <TabsContent
                    days={60}
                    stakeNft={stakeNft}
                    confirmtext={confirmtext}
                  />
                ) : (
                  ""
                )}
              </ContentDiv> */}
              <ContentDiv>
                {activeDiv === 3 && (
                  <TabsContent
                    days={30}
                    stakeNft={stakeNft}
                    confirmtext={confirmtext}
                  />
                )}
              </ContentDiv>
            </RightDiv>
          </MainWrapper>
        </MainDiv>
      </MainSection>
    </>
  );
};

export default StakingPopupComp;
